import * as React from 'react';
import { ComponentProps, InfoText, InputLabel, LabelConfig, Validation, ValidationProps } from 'ui';
import styles from './button-group-panel.scss';

interface ButtonGroupPanelProps extends ComponentProps {
  children: any;
  label?: LabelConfig;
  validation?: ValidationProps;
  childEntitiesReadOnly?: boolean;
}

export const ButtonGroupPanel: React.FC<ButtonGroupPanelProps> = (props: ButtonGroupPanelProps) => {
  const {
    componentId,
    children,
    info,
    label,
    validation,
    childEntitiesReadOnly
  } = props;

  const hasChildren = React.Children.count(children);
  const colSize = !!hasChildren ? 'col-12' : '';
  const hasValidationErrors = (validation && !!validation.messages.length);
  const panelStyle = childEntitiesReadOnly ? styles.hide : styles.buttonGroupPanel;

  return (
    <div id={componentId} className={`${colSize} ${panelStyle}`}>
      {!!hasChildren && !childEntitiesReadOnly ?
        <section className={`${colSize} ${styles.sectionWrapper}`}>
          {hasValidationErrors && <Validation {...validation} />}
          <div className={styles.labelWrapper}>
            {label?.visible && label?.text && <InputLabel text={label?.text} />}
            {info?.visible && info?.text && <InfoText {...info} />}
          </div>
          <div className={`${styles.childrenWrapper} row`}>
            {children}
          </div>
        </section>
        : null}
    </div>
  );
};
